<template>
  <div class="tabsHeader">
    <div style="width: 100%;
  position: fixed;
  z-index:2000">
      <el-tabs
        type="card"
        :value="$route.path"
        @tab-click="tabClick"
        closable
        class="my-tabs"
        @edit="handleTabsEdit"
        @contextmenu.prevent.native="openContextMenu($event)"
        style="position: relative;z-index:1001; "
      >
        <el-tab-pane
          :key="item.path"
          v-for="item in tabsValue"
          :label="item.title"
          :name="item.path"
        >
            <span slot="label"><template v-if="item.hot">🔥</template>{{item.title}}</span>
        </el-tab-pane>
      </el-tabs>
      <ul
        v-show="contextMenuVisible"
        :style="{ left: left + 'px', top: top + 'px' }"
        class="contextmenu"
      >
        <li @click="closeOtherTabs('other')">关闭其他</li>
        <li @click="closeAllTabs">关闭所有</li>
      </ul>
    </div>
    <div style="height:30px;"></div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import storage from "@/utils/storage";
export default {
  data () {
    return {
      contextMenuVisible: false, // 右键显示菜单
      left: 0, // 右键菜单位置
      top: 0, // 右键菜单位置
      otherRouter: {},// 关闭其他路由（当前点击的路由地址）
    };
  },
  computed: { ...mapState({ tabsValue: (state) => state.tabsList }) },
  mounted () {
    // 监听刷新，将数据保存到sessionStorage里
    window.addEventListener("beforeunload", this.setStorage);
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.setStorage);
  },
  watch: {
    contextMenuVisible (value) {
      if (this.contextMenuVisible) {
        document.body.addEventListener("click", this.closeContextMenu);
      } else {
        document.body.removeEventListener("click", this.closeContextMenu);
      }
    }
  },
  methods: {
    setStorage () {
      // 将tabs标签页存储到本地存储中
      storage.setSessionTabsValue(this.tabsValue);
    },
    tabClick ({ name }) {
      // tabs单击
      if (name === this.$route.path) return;
      this.$router.push(name);
    },
    handleTabsEdit (targetPath, action) {
      console.log(targetPath)
      // 删除选项卡
      if (action === "remove") {
        if (targetPath === "/") return;
        let nextTab = {};
        // 找到下一个路由
        this.tabsValue.forEach((item, index) => {
          if (item.path === targetPath) {
            nextTab = this.tabsValue[index + 1] || this.tabsValue[index - 1];
          }
        });
        this.$store.commit("removeTabsValue", targetPath);
        // 如果删除的是当前页，则进行跳转
        targetPath === this.$route.path && this.$router.push(nextTab.path);
      }
    },
    openContextMenu (e) {
      // 右键显示菜单
      // console.log(e.srcElement.innerText);
      //   console.log(e.srcElement.offsetTop);
      if (e.srcElement.id) {
        // console.log(e.srcElement.id)
        // 右键获取当前点击项的路由和标题
        this.otherRouter = {
          name: e.srcElement.id.split('-')[1],
          path: e.srcElement.id.split('-')[1],
          title: e.srcElement.innerText
        }
        // let currentContextTabId = e.srcElement.id.split("-")[1];
        this.contextMenuVisible = true;
        // this.$store.commit("saveCurContextTabId", currentContextTabId);
        this.left = e.clientX;//e.srcElement.offsetLeft + 169;
        this.top = e.clientY;//e.srcElement.offsetTop + 93;
        console.log(e)
      }
    },
    closeContextMenu () {
      // 隐藏右键菜单
      this.contextMenuVisible = false;
    },
    closeAllTabs () {
      // 关闭所有
      // console.log(1);
      this.$store.commit("closeAllTabs")
    },
    closeOtherTabs () {
      // 关闭其他
      // console.log(2);
      // this.otherRouter
      this.$store.commit("closeOtherTabs", this.otherRouter);
    },
  },
};
</script>
<style >
.tabsHeader .el-tabs__header {
  margin: 0;
  width: 87%;
  /*padding-right: 200px;*/
}
.tabsHeader .el-tabs__nav-scroll {
  background-color: white;
  padding-left: 0.15rem;
}
.tabsHeader .el-tabs__item {
  height: 0.48rem;
  line-height: 0.48rem;
}
.tabsHeader
  .el-tabs--card
  > .el-tabs__header
  .el-tabs__item:first-child
  .el-icon-close {
  display: none;
}
.tabsHeader .el-tabs--card > .el-tabs__header .el-tabs__item.is-closable:hover {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.tabsHeader .el-tabs__item {
  font-size: 0.16rem;
  /* color: #0056a4 !important; */
}
.tabsHeader .el-tabs__item.is-active {
  color: #0056a4 !important;
}
.tabsHeader .el-tabs__item:hover {
  color: #0056a4 !important;
}
.tabsHeader .el-tabs__nav-next,
.tabsHeader .el-tabs__nav-prev {
  line-height: 0.5rem;
}
.tabsHeader .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-left: none;
  position: relative;
  border-radius: 0;
}
.tabsHeader .el-tabs--card > .el-tabs__header .el-tabs__item .el-icon-close {
  position: absolute;
  right: 3px;
  top: 50%;
  margin-top: -7px;
}
.contextmenu {
  width: 89px;
  margin: 0;
  border: 1px solid #ccc;
  background: #fff;
  z-index: 3000;
  /*position: absolute;*/
  position: fixed;
  list-style-type: none;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.2);
}
.contextmenu li {
  margin: 0;
  padding: 7px 16px;
}
.contextmenu li:hover {
  background: #f2f2f2;
  cursor: pointer;
}
</style>
